export const page_refresh = () => ({ type: "Page_refresh" });
export const set_page_refresh = (payload) => ({
  type: "Page_refresh",
  payload,
});

export const user = () => ({ type: "user" });
export const set_user = (payload) => ({
  type: "user",
  payload,
});

export const inventory_list = () => ({ type: "Inventory_list" });
export const set_inventory_list = (payload) => ({
  type: "Inventory_list",
  payload,
});

export const product_list = () => ({ type: "Product_list" });
export const set_product_list = (payload) => ({
  type: "Product_list",
  payload,
});

export const product_edit = () => ({ type: "Product_edit" });
export const set_product_edit = (payload) => ({
  type: "Product_edit",
  payload,
});

export const refund_Id = () => ({ type: "Refund_Id" });
export const set_Refund_Id = (payload) => ({
  type: "Refund_Id",
  payload,
});


export const store_list = () => ({ type: "Store_list" });
export const set_store_list = (payload) => ({
  type: "Store_list",
  payload,
});
export const store_edit = () => ({ type: "Store_edit" });
export const set_store_edit = (payload) => ({
  type: "Store_edit",
  payload,
});


export const supplier_list = () => ({ type: "Supplier_list" });
export const set_supplier_list = (payload) => ({
  type: "Supplier_list",
  payload,
});
export const supplier_edit = () => ({ type: "Supplier_edit" });
export const set_supplier_edit = (payload) => ({
  type: "Supplier_edit",
  payload,
});

export const customer_list = () => ({ type: "Customer_list" });
export const set_customer_list = (payload) => ({
  type: "Customer_list",
  payload,
});
export const customer_edit = () => ({ type: "Customer_edit" });
export const set_customer_edit = (payload) => ({
  type: "Customer_edit",
  payload,
});

export const category_list = () => ({ type: "Category_list" });
export const set_category_list = (payload) => ({
  type: "Category_list",
  payload,
});
export const category_edit = () => ({ type: "Category_edit" });
export const set_category_edit = (payload) => ({
  type: "Category_edit",
  payload,
});

export const purchase_list = () => ({ type: "Purchase_list" });
export const set_purchase_list = (payload) => ({
  type: "Purchase_list",
  payload,
});
export const purchase_edit = () => ({ type: "Purchase_edit" });
export const set_purchase_edit = (payload) => ({
  type: "Purchase_edit",
  payload,
});


export const order_list = () => ({ type: "Order_list" });
export const set_order_list = (payload) => ({
  type: "Order_list",
  payload,
});
export const order_edit = () => ({ type: "Order_edit" });
export const set_order_edit = (payload) => ({
  type: "Order_edit",
  payload,
});

export const subcategory_list = () => ({ type: "Subcategory_list" });
export const set_subcategory_list = (payload) => ({
  type: "Subcategory_list",
  payload,
});

export const dropdowns_list = () => ({ type: "Dropdowns_list" });
export const set_dropdowns_list = (payload) => ({
  type: "Dropdowns_list",
  payload,
});

export const subcategory_edit = () => ({ type: "Subcategory_edit" });
export const set_subcategory_edit = (payload) => ({
  type: "Subcategory_edit",
  payload,
});

export const variant_list = () => ({ type: "Variant_list" });
export const set_variant_list = (payload) => ({
  type: "Variant_list",
  payload,
});
export const variant_edit = () => ({ type: "Variant_edit" });
export const set_variant_edit = (payload) => ({
  type: "Variant_edit",
  payload,
});

export const dashboard_recentproduct = () => ({
  type: "Dashbaord_RecentProduct",
});
export const setdashboard_recentproduct = (payload) => ({
  type: "Dashbaord_RecentProduct",
  payload,
});
export const dashboard_expiredproduct = () => ({
  type: "Dashbaord_ExpiredProduct",
});
export const setdashboard_expiredproduct = (payload) => ({
  type: "Dashbaord_ExpiredProduct",
  payload,
});
export const saleshdashboard_recenttransaction = () => ({
  type: "Salesdashbaord_ExpiredProduct",
});
export const setsaleshdashboard_recenttransaction = (payload) => ({
  type: "Salesdashbaord_ExpiredProduct",
  payload,
});
export const brand_list = () => ({ type: "Brand_list" });
export const set_brand_list = (payload) => ({
  type: "Brand_list",
  payload,
});

export const gateway_list = () => ({ type: "Gateway_list" });
export const set_gateway_list = (payload) => ({
  type: "Gateway_list",
  payload,
});

export const courier_list = () => ({ type: "Courier_list" });
export const set_courier_list = (payload) => ({
  type: "Courier_list",
  payload,
});


export const gateway_edit = () => ({ type: "Gateway_edit" });
export const set_gateway_edit = (payload) => ({
  type: "Gateway_edit",
  payload,
});

export const courier_edit = () => ({ type: "Courier_edit" });
export const set_courier_edit = (payload) => ({
  type: "Courier_edit",
  payload,
});



export const brand_edit = () => ({ type: "Brand_edit" });
export const set_brand_edit = (payload) => ({
  type: "Brand_edit",
  payload,
});


export const unit_data = () => ({ type: "Unit_Data" });
export const setunit_data = (payload) => ({
  type: "Unit_Data",
  payload,
});
export const variantattributes_data = () => ({ type: "Variantattribute_Data" });
export const setvariantattributes_data = (payload) => ({
  type: "Variantattribute_Data",
  payload,
});
export const warranty_data = () => ({ type: "Warranty_Data" });
export const setwarranty_data = (payload) => ({
  type: "Warranty_Data",
  payload,
});
export const barcode_data = () => ({ type: "Barcode_Data" });
export const setbarcode_data = (payload) => ({
  type: "Barcode_Data",
  payload,
});
export const departmentlist_data = () => ({ type: "Department_Data" });
export const setdepartmentlist_data = (payload) => ({
  type: "Department_Data",
  payload,
});
export const designation_data = () => ({ type: "Designation_Data" });
export const setdesignation_data = (payload) => ({
  type: "Designation_Data",
  payload,
});
export const shiftlist_data = () => ({ type: "Shiftlist_Data" });
export const setshiftlist_data = (payload) => ({
  type: "Shiftlist_Data",
  payload,
});
export const attendenceemployee_data = () => ({
  type: "Attendenceemployee_Data",
});
export const setattendenceemployee_data = (payload) => ({
  type: "Attendenceemployee_Data",
  payload,
});
export const toogleHeader_data = () => ({ type: "toggle_header" });
export const setToogleHeader = (payload) => ({
  type: "toggle_header",
  payload,
});
export const invoicereport_data = () => ({ type: "Invoicereport_Data" });
export const setinvoicereport_data = (payload) => ({
  type: "Invoicereport_Data",
  payload,
});
export const salesreturns_data = () => ({ type: "Salesreturns_Data" });
export const setsalesreturns_data = (payload) => ({
  type: "Salesreturns_Data",
  payload,
});
export const quotationlist_data = () => ({ type: "Quatation_Data" });
export const setquotationlist_data = (payload) => ({
  type: "Quatation_Data",
  payload,
});
export const customer_data = () => ({ type: "customer_data" });
export const setcustomer_data = (payload) => ({
  type: "customer_data",
  payload,
});
export const userlist_data = () => ({ type: "Userlist_data" });
export const setuserlist_data = (payload) => ({
  type: "Userlist_data",
  payload,
});
export const rolesandpermission_data = () => ({
  type: "Rolesandpermission_data",
});
export const setrolesandpermission_data = (payload) => ({
  type: "Rolesandpermission_data",
  payload,
});
export const deleteaccount_data = () => ({ type: "Deleteaccount_data" });
export const setdeleteaccount_data = (payload) => ({
  type: "Deleteaccount_data",
  payload,
});
export const attendanceadmin_data = () => ({ type: "Attendenceadmin_data" });
export const setattendanceadmin_data = (payload) => ({
  type: "Attendenceadmin_data",
  payload,
});
export const leavesadmin_data = () => ({ type: "Leavesadmin_data" });
export const setleavesadmin_data = (payload) => ({
  type: "Leavesadmin_data",
  payload,
});
export const leavetypes_data = () => ({ type: "Leavestype_data" });
export const setleavetypes_data = (payload) => ({
  type: "Leavestype_data",
  payload,
});
export const holiday_data = () => ({ type: "Holiday_data" });
export const setholiday_data = (payload) => ({
  type: "Holiday_data",
  payload,
});
export const expiredproduct_data = () => ({ type: "Expiredproduct_data" });
export const setexpiredproduct_data = (payload) => ({
  type: "Expiredproduct_data",
  payload,
});
export const lowstock_data = () => ({ type: "Lowstock_data" });
export const setlowstock_data = (payload) => ({
  type: "Lowstock_data",
  payload,
});
export const categotylist_data = () => ({ type: "Categotylist_data" });
export const setcategotylist_data = (payload) => ({
  type: "Categotylist_data",
  payload,
});
export const setLayoutChange = (payload) => ({
  type: "Layoutstyle_data",
  payload,
});

export const setAccessToken = (token) => ({
  type: 'SET_ACCESS_TOKEN',
  payload: token,
});

export const setFullName = (payload) => ({
  type: 'SET_FULL_NAME',
  payload: payload,
});


export const setTenantId = (payload) => ({
  type: 'SET_TENANT_ID',
  payload: payload,
});

export const setPermissions = (payload) => ({
  type: 'SET_PERMISSIONS',
  payload: payload,
});

export const setRoleTitle = (payload) => ({
  type: 'SET_ROLE_TITLE',
  payload: payload,
});
export const setRoleTitleAdmin = (payload) => ({
  type: 'SET_ROLE_TITLE_ADMIN',
  payload: payload,
});




export const clearAccessToken = () => ({
  type: 'CLEAR_ACCESS_TOKEN',
});

export const language = () => ({ type: "language" });
export const set_language = (payload) => ({
  type: "language",
  payload,
});

export const languages = () => ({ type: "languages" });
export const set_languages = (payload) => ({
  type: "languages",
  payload,
});

export const translation = () => ({ type: "translation" });
export const set_translation = (payload) => ({
  type: "translation",
  payload,
});
